import { render } from "./RequestTransfertInscriptionView.vue?vue&type=template&id=1a87119b"
import script from "./RequestTransfertInscriptionView.vue?vue&type=script&lang=js"
export * from "./RequestTransfertInscriptionView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__